<template>
  <section class="infrastructure">
    <section class="infrastructure__banner">
      <section class="content">
        <section class="content__panel">
          <div class="panel_left">
            <div class="title">
              <div>Legend Pay</div>
              Embed Banking Into Your <br />
              Customer Crypto Experience <br />
            </div>
            <div class="payment_wrapper">
              <base-button primary="white" @click="onTouched">
                GET IN TOUCH
              </base-button>
              <div class="payment">
                <icon-visa />
                <icon-mastercard />
                <icon-swift />
                <icon-ach />
                <icon-sepa />
                <icon-faster />
              </div>
            </div>
          </div>
          <div class="panel_right">
            <img
              class="buy-now"
              alt="buy-now"
              src="../assets/img/infrastructure/buy-now.png"
            />
          </div>
        </section>
      </section>
      <div class="scroll-down" @click="scrollToView">
        SCROLL DOWN <svg-arrow />
      </div>
    </section>
    <section class="infrastructure__potential" ref="potential">
      <section class="content">
        <section class="content__panel">
          <div class="panel-left">
            <div id="lottie_box" ref="lottie_box"></div>
          </div>
          <div class="panel-right">
            <div class="title">
              Unlock your growth <br />
              potential with Legend Pay
            </div>
            <div class="sub-title">
              Effortlessly buy/sell crypto with Legend Pay's seamless
              fiat-to-crypto gateway at competitive pricing and with diverse
              payment options.
            </div>
            <div class="link-btn" @click="onTouched">
              TRY LEGEND PAY NOW<svg-arrow />
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="infrastructure__case">
      <section class="content">
        <section class="case-container">
          <section class="panel">
            <div class="panel-left">
              <div class="tips">SHOW CASE</div>
              <img
                class="logo"
                alt="logo"
                src="../assets/logo-partners/Exchanges Wallets/Kucoin.png"
              />
            </div>
            <div class="panel-right">
              <div class="title">
                <span>KUCOIN</span> The integration with Legend Trading allows
                Kucoin users to trade cryptocurrencies with fast fiat
                settlements. Legend’s proprietary trading technology unlocks
                seamless price discovery and best trade.
              </div>
              <div class="action">
                <base-button icon primary="gold" @click="toCaseDetails"
                  >SEE FULL CASE</base-button
                >
                <div class="link-btn" @click="toCase">
                  ALL CASES
                </div>
              </div>
            </div>
          </section>
          <div class="case-view">
            <img
              class="case-desktop"
              alt="case-desktop"
              src="@/assets/img/cases/kucoin-desktop.png"
            />
            <img
              class="case-mobile"
              alt="case-mobile"
              src="@/assets/img/cases/kucoin-mobile.png"
            />
          </div>
        </section>

        <div class="advantage">
          <div class="title">
            Global coverage. <br />
            Accept all payment <br />
            methods
          </div>
          <div class="sub-title">
            Support multiple fiat currencies including USD, EUR, GBP,<br />
            AUD, CHF, CAD, JPY and more in 150+ juridictions.
          </div>
          <div class="list">
            <div class="item">
              Support customers in <span>150+</span> countries
            </div>
            <div class="item">
              Support <span>140+</span> multiple currencies including <br />
              <span>USD, EUR, GBP, CHF, AUD, CAD, JPY </span>and more
            </div>
            <div class="item">
              Accept all major local payment methods
            </div>
          </div>
        </div>
      </section>
    </section>
    <section class="infrastructure__quantity">
      <section class="content">
        <section class="content__grid">
          <section class="content__grid__item">
            <h1>$1B+</h1>
            <h5>
              BANK TRANSFERS AND <br />
              SETTLEMENTS PER MONTH
            </h5>
          </section>
          <section class="content__grid__item">
            <h1>800+</h1>
            <h5>INSTITUTIONAL CLIENTS</h5>
          </section>
          <section class="content__grid__item">
            <h1>150+</h1>
            <h5>COUNTRIES</h5>
          </section>
          <section class="content__grid__item">
            <h1>Millions</h1>
            <h5>RETAIL INVESTORS</h5>
          </section>
        </section>
      </section>
    </section>

    <section class="infrastructure__partners">
      <section class="content">
        <section class="content__panel">
          <div class="title">
            Legend Pay is honored to facilitate the success <br />
            of industry-leading platforms
          </div>
          <partner-display-wall />
        </section>
      </section>
    </section>

    <section class="infrastructure__trade">
      <section class="content">
        <section class="content__panel">
          <div class="panel-left">
            <div class="title">
              INSTITUTIONAL GRADE <br />
              TRADING SERVICE
            </div>
            <div class="sub-title">
              We provides your users with compliant access to the <br />
              most competitive fiat-to-crypto pricing and deep <br />
              liquidity up to $20MM size for one single trade.
            </div>
            <div class="list">
              <div class="item">
                <icon-pig />Lower price slippage and cost of trading
              </div>
              <div class="item">
                <icon-wallet />Transfer large fiat sums into crypto accounts
              </div>
            </div>
          </div>
          <div class="panel-right">
            <img
              alt="bank-service"
              src="../assets/img/infrastructure/bank.png"
            />
          </div>
        </section>
      </section>
    </section>

    <section class="infrastructure__code">
      <section class="content">
        <section class="content__panel">
          <div class="panel-left">
            <img
              class="example"
              alt="example-1"
              src="../assets/img/infrastructure/example-1.png"
            />
            <img
              class="example"
              alt="example-2"
              src="../assets/img/infrastructure/example-2.png"
            />
          </div>
          <div class="panel-right">
            <icon-code class="icon-code" />
            <div class="title">
              Built for <br />
              your native <br />
              mobile app
            </div>
            <div class="sub-title">
              Our payments products are built to unite your business. We support
              all kinds of platforms including web and mobile for an ultimate
              experience.
            </div>
          </div>
        </section>
      </section>
    </section>

    <section class="infrastructure__bottom">
      <section class="content">
        <case-bottom />
      </section>
    </section>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { cloneDeep } from "lodash-es";
import BaseButton from "@/components/BaseButton.vue";
import CaseBottom from "@/components/CaseBottom.vue";
import PartnerDisplayWall from "@/components/PartnerDisplayWall.vue";
import iconCode from "@/assets/img/common/icon-code.svg?inline";
import iconPig from "@/assets/img/common/icon-pig.svg?inline";
import iconWallet from "@/assets/img/common/icon-wallet.svg?inline";
import iconVisa from "@/assets/img/common/visa.svg?inline";
import iconMastercard from "@/assets/img/common/mastercard.svg?inline";
import iconSwift from "@/assets/img/common/swift.svg?inline";
import iconAch from "@/assets/img/common/ach.svg?inline";
import iconSepa from "@/assets/img/common/sepa.svg?inline";
import iconFaster from "@/assets/img/common/faster.svg?inline";
import SvgArrow from "@/assets/img/common/arrow.svg?inline";

export default {
  name: "LegendPay",
  metaInfo: {
    title: "Legend Pay - a fiat-to-crypto payment gateway",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Legend Pay is a fiat-to-crypto payment gateway that bridges the gap between traditional banking systems and the rapidly growing cryptocurrency market. Legend Pay provides a secure and seamless way for users to purchase cryptocurrencies using multiple local currencies, including USD, GBP, EUR, CHF, AUD, CAD, JPY, and more. It supports a vast array of major local payment methods, such as ACH, Swift, SEPA, FPS, Visa, and Mastercard."
      }
    ]
  },
  data() {
    return {
      animation: {}
    };
  },
  components: {
    BaseButton,
    CaseBottom,
    PartnerDisplayWall,
    iconCode,
    iconPig,
    iconWallet,
    iconVisa,
    iconMastercard,
    iconSwift,
    iconAch,
    iconSepa,
    iconFaster,
    SvgArrow,
    SvgArrow
  },
  computed: {
    ...mapState({
      open: state => state.isZendeskOpened
    })
  },
  methods: {
    ...mapActions(["toggleZendesk"]),
    toCaseDetails() {
      this.$router.push({
        name: "cases.detail",
        params: {
          partner: "kucoin"
        }
      });
    },
    toCase() {
      this.$router.push("/cases");
    },
    onTouched() {
      this.toggleZendesk(!this.open);
    },
    scrollToView() {
      this.$refs.potential.scrollIntoView();
    }
  },
  async created() {
    const [lottie, AnimationData] = await Promise.all([
      import(/* webpackChunkName: "lottie-web" */ "lottie-web"),
      import(
        /* webpackChunkName: "lottie-web" */ "@/assets/animation/animation.json"
      )
    ]);
    this.animation = lottie.loadAnimation({
      container: this.$refs.lottie_box,
      renderer: "svg",
      loop: true,
      /*
       * animationData: an Object with the exported animation data.
       * Note: If your animation contains repeaters and you plan to call loadAnimation multiple times with the same animation,
       * please deep clone the object before passing it (see #1159 and #2151.)
       * https://github.com/airbnb/lottie-web/issues/1159
       * https://github.com/airbnb/lottie-web/issues/2151
       */
      animationData: cloneDeep(AnimationData.default)
    });
  },
  destroyed() {
    this.$nextTick(() => {
      this.animation?.destroy?.();
      this.animation = {};
    });
  }
};
</script>

<style scoped lang="scss">
@import "https://github.githubassets.com/assets/gist-embed-4ac6018bcc05457cde2f66d2e7299d11.css";

.infrastructure {
  background: colors(light);

  &__banner {
    position: relative;
    background: colors(dark);
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 60.625rem;
    margin-top: -6.25rem;
    margin-bottom: 4.25rem;
    overflow: hidden;

    &::before {
      content: "";
      background-image: linear-gradient(
        to bottom,
        rgba(3, 4, 10, 0) 0%,
        #03040a 88%
      );
      position: absolute;
      width: 100%;
      height: 20rem;
      bottom: 0rem;
      left: 0;
      pointer-events: none;
      background-size: contain;
      z-index: 4;
    }

    &::after {
      content: "";
      background: url("../assets/img/infrastructure/wide-bg.png") no-repeat 50%
        50%;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0rem;
      left: 0;
      pointer-events: none;
      background-size: cover;
    }

    .content {
      width: $legend-max-width;
      position: relative;
      z-index: 2;

      &__panel {
        display: flex;
        .panel_left {
          padding: 14.24375rem 0rem 0rem 3.75rem;

          .title {
            font-size: 2.4rem;
            font-weight: 600;
            line-height: 2;
            color: colors(light);
            margin-bottom: 3.4375rem;
            & > div {
              color: colors(theme);
              font-size: 3.875rem;
              line-height: 1.32;
              margin-bottom: 2.25rem;
            }
          }

          .payment_wrapper {
            display: flex;
            .payment {
              display: flex;
              align-items: center;
              margin-left: 2.625rem;
              svg {
                &:not(:last-child) {
                  margin-right: 1.125rem;
                }
              }
            }
          }
        }

        .panel_right {
          margin-left: 11rem;
          position: relative;
          padding-top: 14rem;
          &::after {
            content: "";
            background: url("../assets/img/infrastructure/iphone-bg.png")
              no-repeat 0 0;
            position: absolute;
            width: 26.3125rem;
            height: 53.6875rem;
            top: 7.1875rem;
            left: 11.25rem;
            pointer-events: none;
            background-size: contain;
            z-index: -1;
          }
          .buy-now {
            width: 22.125rem;
          }
        }
      }
    }

    .scroll-down {
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 3.75rem;
      z-index: 5;
      font-size: 1rem;
      font-weight: 600;
      line-height: 2;
      color: rgba(255, 255, 255, 0.2);
      cursor: pointer;

      svg {
        transform: rotate(90deg);
        margin-left: 1rem;
      }
    }
  }

  &__potential {
    margin-bottom: 4.6875rem;
    .content {
      width: $legend-max-width;
      margin: 0 auto;
      padding: 0 3.75rem;
      &__panel {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5.875rem 7.5rem;
        border-radius: 1.875rem;
        background-color: rgba(17, 18, 36, 0.02);
        position: relative;

        &::after {
          content: "";
          width: 38.875rem;
          height: 18.25rem;
          pointer-events: none;
          background: url("../assets/img/common/blue-line-graph.png") no-repeat
            0 0;
          background-size: cover;
          margin: auto;
          position: absolute;
          left: 0rem;
          top: 3.8rem;
        }

        .panel-left {
          #lottie_box {
            width: 22.25rem;
            height: 20rem;
            box-shadow: 0rem 0rem 0.625rem rgba(0, 0, 0, 0.5);
            border-radius: 1.25rem;
            position: relative;
            z-index: 2;
            background: white;
          }
        }
        .panel-right {
          width: 39.375rem;
          margin-left: 10.125rem;
          .title {
            font-size: 2.5rem;
            font-weight: 600;
            line-height: 1.5;
            letter-spacing: -0.1px;
            color: colors(dark);
            margin-bottom: 3.75rem;
          }
          .sub-title {
            font-size: 1.25rem;
            line-height: 1.6;
            letter-spacing: -0.1px;
            color: colors(dark);
            margin-bottom: 1.25rem;
          }

          .link-btn {
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            text-decoration: underline;
            color: colors(theme);
            display: flex;
            align-items: center;

            svg {
              margin-left: 0.625rem;
              width: 0.5625rem;
            }
          }
        }
      }
    }
  }

  &__case {
    margin-bottom: 10rem;

    .content {
      width: $legend-max-width;
      padding: 0 3.75rem;
      margin: 0 auto;

      .case-container {
        background-color: rgba(17, 18, 36, 0.02);
        border-radius: 1.875rem;
        padding: 3.75rem 0rem;
        margin-bottom: 4.6875rem;

        .panel {
          display: flex;
          margin-bottom: 5.625rem;

          .panel-left {
            padding-left: 6.25rem;
            .tips {
              padding-left: 1.5rem;
              font-size: 1rem;
              color: rgba(17, 18, 36, 0.5);
            }
            .logo {
              width: 17.1875rem;
            }
          }
          .panel-right {
            width: 49.5rem;
            margin-left: 3.3125rem;
            .title {
              font-size: 1.25rem;
              line-height: 1.6;
              letter-spacing: -0.11px;
              color: colors(dark);
              margin-bottom: 1.875rem;

              span {
                font-weight: 600;
              }
            }
            .action {
              display: flex;
              align-items: center;
              .link-btn {
                @include fontSize(small);
                margin-left: 2.5rem;
                cursor: pointer;
                text-decoration: underline;
                font-weight: 500;
              }
            }
          }
        }

        .case-view {
          display: flex;
          align-items: center;
          justify-content: center;

          .case-desktop {
            height: 34.375rem;
            margin-left: -2.375rem;
          }
          .case-mobile {
            height: 34.375rem;
          }
        }
      }

      .advantage {
        position: relative;
        padding: 8.125rem 0rem 8.125rem 6.25rem;
        background-color: rgba(17, 18, 36, 0.02);
        border-radius: 1.875rem;
        // padding: 0 3.75rem;

        &::after {
          content: "";
          width: 42.9375rem;
          height: 31.9375rem;
          pointer-events: none;
          background: url("../assets/img/infrastructure/map.png") no-repeat 0 0;
          background-size: cover;
          margin: auto;
          position: absolute;
          right: 0rem;
          top: 6rem;
        }

        .title {
          font-size: 2.5rem;
          font-weight: 600;
          line-height: 1.2;
          color: colors(dark);
          margin-bottom: 2.125rem;
        }
        .sub-title {
          font-size: 1.25rem;
          line-height: 1.6;
          letter-spacing: -0.11px;
          color: colors(dark);
          margin-bottom: 2.125rem;
        }

        .list {
          .item {
            &:not(:last-child) {
              margin-bottom: 1.25rem;
            }

            &::before {
              content: "";
              width: 1.875rem;
              height: 1.5625rem;
              background: url(../assets/img/common/icon-check.svg);
              background-size: contain;
              position: absolute;
              left: 0;
              top: 0;
            }

            font-size: 1.25rem;
            font-weight: 500;
            line-height: 1.6;
            letter-spacing: -0.11px;
            color: #0a0a16;
            position: relative;
            padding-left: 3.75rem;
            span {
              font-weight: bold;

              color: colors(theme);
            }
          }
        }
      }
    }
  }

  .line {
    width: 72.5rem;
    height: 1.25rem;
    background: rgba(17, 18, 36, 0.02);
    margin: 0 auto;
    border-radius: 1.25rem;
  }

  &__quantity {
    background: colors(light);
    margin-bottom: 9rem;
    .content {
      width: $legend-max-width;
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 13.4375rem;
        top: -4rem;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background: url("../assets/img/shadowbg/chartline-gold.svg") no-repeat
          50% 50%;
        background-size: contain;
        pointer-events: none;
      }

      & > h5 {
        @include fontSize(base);

        font-weight: bold;
        text-align: center;
        color: colors(theme);
        margin-bottom: 3.625rem;
      }

      &__grid {
        justify-content: space-evenly;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        // margin-bottom: 5.875rem;

        &__item {
          h1 {
            @include fontSize(super);

            font-weight: bold;
            line-height: 3.75rem;
            color: colors(theme);
            text-align: center;
            margin: 0rem 0rem 2rem 0rem;
          }

          h5 {
            @include fontSize(base);

            text-align: center;
            color: colors(dark);
            margin: 0rem;
          }
        }
      }

      &__line {
        @include line;
      }
    }
  }

  &__partners {
    background: colors(light);
    margin-bottom: 4.6875rem;
    .content {
      width: $legend-max-width;
      margin: auto;
      padding: 0 3.75rem;

      &__panel {
        border-radius: 1.875rem;
        background-color: rgba(17, 18, 36, 0.02);
        position: relative;
        padding: 4.375rem 0rem;
        .title {
          font-size: 1.875rem;
          font-weight: 600;
          line-height: 1.67;
          color: colors(dark);
          text-align: center;
          margin-bottom: 3.5625rem;
        }
      }
    }
  }

  &__trade {
    background: colors(light);
    margin-bottom: 4.6875rem;
    .content {
      width: $legend-max-width;
      margin: auto;
      padding: 0 3.75rem;

      &__panel {
        display: flex;
        align-items: center;
        background-color: rgba(17, 18, 36, 0.02);
        border-radius: 1.875rem;
        .panel-left {
          padding-left: 6.25rem;
          padding-top: 5.90625rem;
          padding-bottom: 5.625rem;

          color: colors(dark);

          .title {
            font-size: 2.5rem;
            font-weight: 600;
            line-height: 1.2;
            margin-bottom: 2.125rem;
          }
          .sub-title {
            font-size: 1.25rem;
            line-height: 1.6;
            letter-spacing: -0.11px;
            margin-bottom: 2.125rem;
          }
          .list {
            font-size: 1.25rem;
            font-weight: 500;
            line-height: 1.6;
            letter-spacing: -0.11px;
            .item {
              display: flex;
              align-items: center;
              &:not(:last-child) {
                margin-bottom: 1.25rem;
              }
              svg {
                margin-right: 1.875rem;
              }
            }
          }
        }
        .panel-right {
          margin-left: 7.5rem;
          img {
            width: 28.8125rem;
          }
        }
      }
    }
  }

  &__code {
    background: colors(light);
    position: relative;

    .content {
      width: $legend-max-width;
      padding: 0 3.75rem;
      margin: 0 auto 10rem auto;
      &__panel {
        display: flex;
        background-color: rgba(17, 18, 36, 0.02);
        border-radius: 1.875rem;
        padding: 50px 20px;
        .panel-left {
          display: flex;
          .example {
            width: 18.75rem;
          }
        }
        .panel-right {
          width: 31.875rem;
          padding: 4.75rem 3.75rem 0rem 3.5rem;
          border-radius: 1.875rem;
          margin-left: 7.5rem;
          background-image: linear-gradient(
            to bottom,
            rgba(245, 245, 247, 0.4),
            rgba(251, 251, 252, 0)
          );
          position: relative;

          .icon-code {
            width: 6.25rem;
            margin-bottom: 1.25rem;
          }
          .title {
            font-size: 3.75rem;
            font-weight: 600;
            line-height: 1.13;
            color: colors(dark);
            margin-bottom: 2.25rem;
          }

          .sub-title {
            font-size: 1.25rem;
            line-height: 1.6;
            letter-spacing: -0.3px;
            color: colors(dark);
          }
        }
      }
    }
  }

  &__bottom {
    .content {
      width: $legend-max-width;
      margin: auto;
    }
  }
}
</style>
